import { useEffect } from "react";

const useClickAway = (
  ref: React.RefObject<HTMLElement>,
  handleClick: (event: MouseEvent) => void
) => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      // @ts-ignore
      if (ref && ref.current && !ref.current.contains(event.target)) {
        handleClick(event);
        // event.stopPropagation();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

export default useClickAway;
